import React from "react";
import VerificationRedirect from "containers/Verification/VerificationRedirect";

function VerifyPage(props = {}) {

    return (
        <>
            <VerificationRedirect />
        </>
    )
}

export default VerifyPage;

